'use client';

import { twMerge } from '@shared/themes';
import { NumberFormats as nf, useCurrencyFormatter } from '@shared/utils';
import type { ComponentProps } from 'react';

type JackpotByCharacterProps = ComponentProps<'span'> & {
  value: number;
  characterWidth?: string;
};

function Character({ char, characterWidth = 'w-3.5' }: { char: string; characterWidth?: string }) {
  return <span className={twMerge('flex items-center justify-center', ['.', ','].includes(char) ? 'w-1.5' : characterWidth)}>{char}</span>;
}

function JackpotByCharacter({ className, value, characterWidth, ...props }: JackpotByCharacterProps) {
  const currencyFormatter = useCurrencyFormatter();
  const jsCharacters = currencyFormatter(value).format(nf.WITH_DECIMALS).get().split('');
  return (
    <span className={className} {...props}>
      {jsCharacters.map((char, index) => (
        <Character char={char} characterWidth={characterWidth} key={index} />
      ))}
    </span>
  );
}

export { Character, JackpotByCharacter };
